import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
    postApiWithAuthorization,
    getApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

export const GetAvailableCouponList = async (params) => {
    const url = `${NewUpdatedBaseUrl}/CouponCode/GetAvailableCouponList`;
    const res = await postApiWithAuthorization(url, params);

    return res;
};

export const GetCheckCouponCode = async (params) => {
    const url = `${NewUpdatedBaseUrl}/CouponCode/GetCheckCouponCode`;
    const res = await postApiWithAuthorization(url, params);

    return res;
};
